'use client'

import { useCallback } from 'react'

import { Header } from './header'
import { LeaderboardList } from './leaderboard-list'

export type LeaderboardType =
  | {
      type: 'challenge'
      from: 'school' | 'admin' | 'web'
      challengeId: string
    }
  | {
      type: 'course'
      from: 'school' | 'web'
      courseId: string
    }

type LeaderboardProps = LeaderboardType & {
  learnEnrollmentId?: string
}

export function Leaderboard({ learnEnrollmentId, ...p }: LeaderboardProps) {
  const courseId = p.type === 'course' ? p.courseId : undefined
  const challengeId = p.type === 'challenge' ? p.challengeId : undefined

  const resolveIds = useCallback(() => {
    return { courseId, challengeId, learnEnrollmentId }
  }, [courseId, challengeId, learnEnrollmentId])

  return (
    <main className='srd:flex srd:flex-col srd:items-center srd:justify-center srd:bg-neutral-black srd:w-full'>
      <Header {...p} />

      <section className='srd:w-full srd:max-w-[1440px] srd:mx-auto srd:pt-6 srd:px-4 srd:min-h-screen srd:pb-20'>
        <LeaderboardList ids={resolveIds()} />
      </section>
    </main>
  )
}
